<h2 mat-dialog-title class="mb-0 px-4">Update Credits</h2>
<mat-dialog-content class="p-4 pb-0">
  <form
    [formGroup]="creditsForm"
    (ngSubmit)="onSubmit()"
    class="flex w-full gap-4"
  >
    <div class="form-group w-100">
      <input
        name="credits"
        type="number"
        formControlName="credits"
        placeholder="Enter credits to add"
        min="1"
        onWheel="this.blur()"
        onKeyDown="if(event.key === 'e' || event.key === '-' || event.key === '+') event.preventDefault()"
        [ngClass]="{
          'is-invalid':
            creditsForm.get('credits')?.invalid &&
            creditsForm.get('credits')?.touched
        }"
      />
      <div
        *ngIf="
          creditsForm.get('credits')?.invalid &&
          creditsForm.get('credits')?.touched
        "
        class="error-message"
      >
        <span *ngIf="creditsForm.get('credits')?.hasError('required')">
          Credits is required
        </span>
        <span *ngIf="creditsForm.get('credits')?.hasError('min')">
          Credits must be at least 1
        </span>
        <span *ngIf="creditsForm.get('credits')?.hasError('max')">
          Credits must be less than 10,00,000
        </span>
      </div>
    </div>

    <div class="form-group w-100">
      <mat-form-field appearance="outline" class="w-100 select_h_42">
        <mat-select
          formControlName="transactionType"
          [ngClass]="{
            'is-invalid':
              creditsForm.get('transactionType')?.invalid &&
              creditsForm.get('transactionType')?.touched
          }"
        >
          <mat-option
            *ngFor="let option of transactionOptions"
            [value]="option.value"
          >
            {{ option.label }}
          </mat-option>
        </mat-select>
        <mat-error
          *ngIf="
            creditsForm.get('transactionType')?.invalid &&
            creditsForm.get('transactionType')?.touched
          "
        >
          Transaction Type is required
        </mat-error>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="p-4 pt-0">
  <div class="flex gap-2">
    <app-common-button
      text="Cancel"
      variant="secondary"
      (onClick)="onCancel()"
      [disabled]="isLoading"
      [type]="'button'"
    ></app-common-button>
    <app-common-button
      text="Update Credits"
      variant="primary"
      (onClick)="onSubmit()"
      [disabled]="isLoading"
      [type]="'submit'"
    ></app-common-button>
  </div>
</mat-dialog-actions>
